<template>
    <div>
      <PageHeading
        :default-heading="pageHeader()"
        :edit-heading="pageHeader()"
      />
      <form
        novalidate="novalidate"
        @submit.prevent
      >
        <div class="pvd-container container-divider">
        <p>
          You are a few short minutes away from completing your application! We'll
          need {{ idVerificationName() }} to grab
          <strong> either of the following </strong> for additional verification:
        </p>
        <br>
        <ul>
          <li>Driver's License</li>
          <li>Passport</li>
        </ul>
        <br>
        <p>
          Once you click the button below,
          <strong>
            {{ idVerificationName() }} will receive a text message at their mobile
            number with a link to get started: {{ maskedPhoneNumber() }}.
          </strong>
        </p>
        </div>
          <NavigationComponent
            @next-action="handleWidgetSubmit"
          />
          <div class="pvd-container">
            <p class="light-text">
              You are agreeing to recieve a text message with a link to the ID service
              website that is owned and operated by Socure. Socure is not affiliated
              with Fidelity. Msg & data rates may apply. Text "STOP" to automatically
              opt out of receiving text messages.
            </p>
          </div>
      </form>
  </div>
</template>

<script>
import NavigationComponent from '../components/NavigationComponent.vue';
import PageHeading from '../components/PageHeading.vue';
import utilityFunctions from '../mixins/utility';
import validationHelper from '../mixins/validationHelper';
import widgetHelper from '../mixins/widgetHelper';
import dataHelper from '../mixins/dataHelper';
import dataSanitize from '../mixins/dataSanitize';
import pageNavigationHelper from '../mixins/pageNavigationHelper';

export default {
  name: 'TrustDocVerifyInitiate',
  components: {
    NavigationComponent,
    PageHeading,
  },
  mixins: [
    utilityFunctions,
    validationHelper,
    widgetHelper,
    dataHelper,
    dataSanitize,
    pageNavigationHelper,
  ],
  mounted() {
    this.$store.commit('currentState/updateField', { path: 'stateName', value: 'trust-doc-verify-initiate' });
  },
  methods: {
    pageHeader() {
      const { currentUserIndex } = this.getInstanceData().currentState;
      const { formData } = this.getInstanceData();
      if (Object.hasOwn(this.getInstanceData().currentState, 'currentUserIndex') && Number.isInteger(this.getInstanceData().currentState.currentUserIndex)) {
        return 'We\'ll need some documentation from '.concat(`${formData.additionalUsers[currentUserIndex]?.firstName} ${formData.additionalUsers[currentUserIndex]?.lastName}`);
      }
      return 'We\'ll need some documentation from '.concat(`${formData.primaryUser?.firstName} ${formData.primaryUser?.lastName}`);
    },
    idVerificationName() {
      const { currentUserIndex } = this.getInstanceData().currentState;
      const { formData } = this.getInstanceData();
      if (Object.hasOwn(this.getInstanceData().currentState, 'currentUserIndex') && Number.isInteger(this.getInstanceData().currentState.currentUserIndex)) {
        return `${formData.additionalUsers[currentUserIndex]?.firstName} ${formData.additionalUsers[currentUserIndex]?.lastName}`;
      }
      return `${formData.primaryUser?.firstName} ${formData.primaryUser?.lastName}`;
    },
    maskedPhoneNumber() {
      const { currentUserIndex } = this.getInstanceData().currentState;
      const { formData } = this.getInstanceData();
      const phoneNumber = Object.hasOwn(this.getInstanceData().currentState, 'currentUserIndex') && Number.isInteger(this.getInstanceData().currentState.currentUserIndex) ? formData.additionalUsers[currentUserIndex]?.dayPhone : formData.primaryUser?.dayPhone;
      return '***-***-'.concat(phoneNumber.replace(/\D/g, '').slice(-4));
    },
  },
};
</script>

<style scoped>
.top-margin-zero {
  margin-top: 0;
}

.light-text {
  color: #666666 !important;
}
</style>
